import { useEffect, useState } from "react";
import AndroidAppModal from "../Components/AndroidAppModal";
import AndroidDownloadFloatingButton from "../Components/AndroidDownloadFloatingButton";

export default function Home() {
    const [showAndroidModal, setShowAndroidModal] = useState(false);
    return (
        <>
            <AndroidAppModal isOpen={showAndroidModal} onClose={() => setShowAndroidModal(false)} />
            <AndroidDownloadFloatingButton onClick={() => setShowAndroidModal(true)} />
            
            <div className="main-break-line">
                <div className="line_page">
                    <span></span>
                </div>

                <div className="header-landing-fixed-block"></div>


                <div className="tf-break-wrap" data-line="4">
                    <div className="line"></div>
                    <div className="wrap">
                        <span className="dot-square"></span>
                        <span className="dot-square"></span>
                    </div>
                </div>


                <div className="landing-intro">
                    <div className="container-6">
                        <div className="content flat-spacing-5 text-center">
                            <div className="bg-img">
                                <img className="wow fadeZoom" loading="lazy" width="1322" height="640"
                                    src="images/background.png" alt="Image" />
                            </div>
                            <div className="land-tag wow fadeInUp">
                                <div className="ic-wrap left">
                                    <img className="icon" src="/images/sub-heading-right-arrow.webp" alt="" />
                                </div>
                                <span className="text-uppercase text-primary fw-semibold lh-20">
                                    Stream. Record. Share.
                                </span>
                                <div className="ic-wrap right">
                                    <img className="icon" src="/images/sub-heading-left-arrow.webp" alt="" />
                                </div>
                            </div>
                            <p className="title text-72-76 text-black fw-medium letter-space--3 wow fadeInUp">
                                Edge-Enabled Drone Streaming &<br className="d-none d-sm-block" />
                                <span className="animationtext letters rotate-3 text-primary ps-sm-3">
                                    <span className="cd-words-wrapper">
                                        <span className="item-text is-visible">Intelligence&nbsp;Platform</span>
                                        <span className="item-text is-hidden">Intelligence&nbsp;Platform</span>
                                        <span className="item-text is-hidden">Intelligence&nbsp;Platform</span>
                                    </span>
                                </span>
                                
                            </p>
                            <p className="desc fw-medium text-body-2 cl-text-3 wow fadeInUp">
                                Managing live streams is easy with full control, high-quality<br className="d-none d-md-block" /> playback, and on-demand downloads.
                                
                            </p>
                            <div className="group-btn flex-wrap">
                                <div className="wow fadeInUp">
                                    <a href="#" target="_blank" className="action tf-btn-2" data-bs-toggle="modal" data-bs-target="#reqDemo">
                                        <div className="wrap-text text-body-2 fw-medium text-white">
                                            <span className="text text-linear">
                                                Request Demo
                                            </span>
                                        </div>
                                    </a>
                                </div>
                                <div className="wow fadeInUp" data-wow-delay="0.1s">
                                    <a href="https://drone.infinitivehost.org/" target="_blank" className="action tf-btn-2 style-dark">
                                        <div className="wrap-text text-body-2 fw-medium text-white">
                                            <span className="text">
                                                View Website
                                            </span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="section-figma-colect flat-spacing-5 pt-0">
                    <div className="container-6">
                        <div className="web-safari-emulator">
                            <div className="tool-bar">
                                <div className="tool-left">
                                    <ul className="web-btn-control">
                                        <li className="br-dot red"></li>
                                        <li className="br-dot yellow"></li>
                                        <li className="br-dot green"></li>
                                    </ul>
                                    <ul className="web-direc">
                                        <li className="sidebar-toogle">
                                            <svg width="19" height="15" viewBox="0 0 19 15" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <g>
                                                    <path
                                                        d="M2.57031 14.6016H15.9375C17.6328 14.6016 18.5156 13.7266 18.5156 12.0547V2.54688C18.5156 0.875 17.6328 0 15.9375 0H2.57031C0.882812 0 0 0.867188 0 2.54688V12.0547C0 13.7266 0.882812 14.6016 2.57031 14.6016ZM2.67188 13.0469C1.95312 13.0469 1.55469 12.6719 1.55469 11.9141V2.6875C1.55469 1.92969 1.95312 1.55469 2.67188 1.55469H6.23438V13.0469H2.67188ZM15.8359 1.55469C16.5547 1.55469 16.9531 1.92969 16.9531 2.6875V11.9141C16.9531 12.6719 16.5547 13.0469 15.8359 13.0469H7.71094V1.55469H15.8359ZM4.70312 4.41406C4.98438 4.41406 5.21875 4.17188 5.21875 3.90625C5.21875 3.64062 4.98438 3.40625 4.70312 3.40625H3.10156C2.82031 3.40625 2.58594 3.64062 2.58594 3.90625C2.58594 4.17188 2.82031 4.41406 3.10156 4.41406H4.70312ZM4.70312 6.51562C4.98438 6.51562 5.21875 6.28125 5.21875 6.00781C5.21875 5.74219 4.98438 5.50781 4.70312 5.50781H3.10156C2.82031 5.50781 2.58594 5.74219 2.58594 6.00781C2.58594 6.28125 2.82031 6.51562 3.10156 6.51562H4.70312ZM4.70312 8.60938C4.98438 8.60938 5.21875 8.38281 5.21875 8.10938C5.21875 7.84375 4.98438 7.61719 4.70312 7.61719H3.10156C2.82031 7.61719 2.58594 7.84375 2.58594 8.10938C2.58594 8.38281 2.82031 8.60938 3.10156 8.60938H4.70312Z"
                                                        fill="#797979" />
                                                </g>
                                            </svg>
                                        </li>
                                        <li className="box-direc-btn">
                                            <span className="web-btn prev">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <g>
                                                        <path
                                                            d="M14.4062 19.0234L8.32812 13.0781C8.11719 12.8672 8.00781 12.6328 8.00781 12.3594C8.00781 12.0859 8.11719 11.8359 8.33594 11.6328L14.4141 5.69531C14.5859 5.52344 14.8047 5.42969 15.0547 5.42969C15.5781 5.42969 15.9844 5.83594 15.9844 6.35156C15.9844 6.60156 15.8828 6.84375 15.7031 7.02344L10.2344 12.3516L15.7031 17.6953C15.8828 17.875 15.9844 18.1094 15.9844 18.3672C15.9844 18.8828 15.5781 19.2891 15.0547 19.2891C14.8047 19.2891 14.5859 19.1953 14.4062 19.0234Z"
                                                            fill="#797979" />
                                                    </g>
                                                </svg>
                                            </span>
                                            <span className="web-btn next">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <g>
                                                        <path
                                                            d="M8.9375 19.2812C9.19531 19.2812 9.40625 19.1875 9.58594 19.0156L15.6641 13.0781C15.875 12.8594 15.9844 12.6328 15.9844 12.3516C15.9844 12.0781 15.8828 11.8359 15.6641 11.6328L9.58594 5.6875C9.40625 5.51562 9.19531 5.42188 8.9375 5.42188C8.41406 5.42188 8.00781 5.82812 8.00781 6.34375C8.00781 6.59375 8.11719 6.83594 8.28906 7.01562L13.7656 12.3594L8.28906 17.6875C8.10938 17.875 8.00781 18.1016 8.00781 18.3594C8.00781 18.875 8.41406 19.2812 8.9375 19.2812Z"
                                                            fill="#797979" />
                                                    </g>
                                                </svg>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="tool-center">
                                    <div className="ic-wrap">
                                        <svg width="26" height="24" viewBox="0 0 26 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <g>
                                                <path
                                                    d="M13 20C13.1489 20 13.3723 19.9528 13.5792 19.8428C18.3452 17.3818 20 16.2418 20 13.3799V7.44373C20 6.50025 19.6111 6.16216 18.7837 5.82408C17.8652 5.45455 14.779 4.43243 13.8771 4.14152C13.604 4.05504 13.2813 4 13 4C12.7187 4 12.396 4.07076 12.1229 4.14152C11.221 4.38526 8.13475 5.46241 7.21631 5.82408C6.38889 6.1543 6 6.50025 6 7.44373V13.3799C6 16.2418 7.66312 17.3661 12.4125 19.8428C12.6277 19.9528 12.8511 20 13 20ZM13.4468 5.58821C14.5307 5.99705 16.8889 6.79115 18.13 7.20786C18.3617 7.29435 18.4196 7.41228 18.4196 7.69533V13.0889C18.4196 15.3926 17.2033 16.0138 13.4716 18.1523C13.24 18.286 13.1241 18.3332 13.0083 18.3332V5.50172C13.1241 5.50172 13.2482 5.52531 13.4468 5.58821Z"
                                                    fill="#808080" />
                                            </g>
                                        </svg>
                                    </div>
                                    <div className="box-search">
                                        <div className="main-search">
                                            <div className="ic-wrap">
                                                <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <g>
                                                        <path
                                                            d="M4.99463 9.99121C6.00391 9.99121 6.94971 9.68652 7.73682 9.16602L10.5171 11.9526C10.7012 12.1304 10.936 12.2192 11.1899 12.2192C11.7168 12.2192 12.104 11.8066 12.104 11.2861C12.104 11.0449 12.0215 10.8101 11.8438 10.6323L9.08252 7.8584C9.65381 7.05225 9.99023 6.06201 9.99023 4.99561C9.99023 2.24707 7.74316 0 4.99463 0C2.25244 0 -0.000976562 2.24707 -0.000976562 4.99561C-0.000976562 7.74414 2.24609 9.99121 4.99463 9.99121ZM4.99463 8.6582C2.98242 8.6582 1.33203 7.00781 1.33203 4.99561C1.33203 2.98975 2.98242 1.33301 4.99463 1.33301C7.00684 1.33301 8.65723 2.98975 8.65723 4.99561C8.65723 7.00781 7.00684 8.6582 4.99463 8.6582Z"
                                                            fill="#AAAAAA" />
                                                    </g>
                                                </svg>
                                            </div>
                                            <div className="ip">
                                                https://drone.infinitivehost.org/...
                                            </div>
                                        </div>
                                        <div className="ic-wrap reload">
                                            <svg width="29" height="24" viewBox="0 0 29 24" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.5">
                                                    <g>
                                                        <path
                                                            d="M14.2734 10.9766C14.5 10.9766 14.6797 10.9062 14.8203 10.7578L18.0234 7.53125C18.1953 7.35938 18.2734 7.17188 18.2734 6.95312C18.2734 6.74219 18.1875 6.53906 18.0234 6.38281L14.8203 3.125C14.6797 2.96875 14.5 2.89062 14.2734 2.89062C13.8516 2.89062 13.5156 3.24219 13.5156 3.67188C13.5156 3.88281 13.5938 4.05469 13.7266 4.20312L15.5938 6.03125C15.2266 5.97656 14.8516 5.94531 14.4766 5.94531C10.6094 5.94531 7.51562 9.03906 7.51562 12.9141C7.51562 16.7891 10.6328 19.9062 14.5 19.9062C18.375 19.9062 21.4844 16.7891 21.4844 12.9141C21.4844 12.4453 21.1562 12.1094 20.6875 12.1094C20.2344 12.1094 19.9297 12.4453 19.9297 12.9141C19.9297 15.9297 17.5156 18.3516 14.5 18.3516C11.4922 18.3516 9.07031 15.9297 9.07031 12.9141C9.07031 9.875 11.4688 7.46875 14.4766 7.46875C14.9844 7.46875 15.4531 7.50781 15.8672 7.57812L13.7344 9.6875C13.5938 9.82812 13.5156 10 13.5156 10.2109C13.5156 10.6406 13.8516 10.9766 14.2734 10.9766Z"
                                                            fill="#666666" />
                                                    </g>
                                                </g>
                                            </svg>

                                        </div>
                                    </div>
                                </div>
                                <div className="tool-right">
                                    <ul className="web-nav-control">
                                        <li>
                                            <svg width="31" height="24" viewBox="0 0 31 24" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <g>
                                                    <path
                                                        d="M15.5078 14.4141C15.9062 14.4141 16.2344 14.0859 16.2344 13.6953V5.83594L16.1797 4.67969L16.6562 5.25L17.75 6.41406C17.875 6.55469 18.0547 6.625 18.2344 6.625C18.5938 6.625 18.8906 6.36719 18.8906 6C18.8906 5.80469 18.8125 5.66406 18.6797 5.53125L16.0625 3.00781C15.875 2.82031 15.6953 2.75781 15.5078 2.75781C15.3125 2.75781 15.1406 2.82031 14.9531 3.00781L12.3281 5.53125C12.1953 5.66406 12.1172 5.80469 12.1172 6C12.1172 6.36719 12.4062 6.625 12.7656 6.625C12.9453 6.625 13.1328 6.55469 13.2578 6.41406L14.3516 5.25L14.8359 4.67188L14.7734 5.83594V13.6953C14.7734 14.0859 15.1016 14.4141 15.5078 14.4141ZM11 20.6562H20C21.6953 20.6562 22.5703 19.7812 22.5703 18.1094V10.4297C22.5703 8.75781 21.6953 7.88281 20 7.88281H17.8906V9.4375H19.8984C20.6094 9.4375 21.0156 9.8125 21.0156 10.5625V17.9688C21.0156 18.7188 20.6094 19.0938 19.8984 19.0938H11.1016C10.3828 19.0938 9.98438 18.7188 9.98438 17.9688V10.5625C9.98438 9.8125 10.3828 9.4375 11.1016 9.4375H13.1328V7.88281H11C9.3125 7.88281 8.42969 8.75 8.42969 10.4297V18.1094C8.42969 19.7812 9.3125 20.6562 11 20.6562Z"
                                                        fill="#999999" />
                                                </g>
                                            </svg>

                                        </li>
                                        <li>
                                            <svg width="30" height="24" viewBox="0 0 30 24" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <g>
                                                    <g>
                                                        <path
                                                            d="M15 19.0156C15.4922 19.0156 15.8906 18.6094 15.8906 18.1484V13.2578H20.6562C21.1328 13.2578 21.5391 12.8594 21.5391 12.3672C21.5391 11.8828 21.1328 11.4766 20.6562 11.4766H15.8906V6.58594C15.8906 6.11719 15.4922 5.71875 15 5.71875C14.5156 5.71875 14.1094 6.11719 14.1094 6.58594V11.4766H9.34375C8.88281 11.4766 8.46094 11.8828 8.46094 12.3672C8.46094 12.8594 8.88281 13.2578 9.34375 13.2578H14.1094V18.1484C14.1094 18.6094 14.5156 19.0156 15 19.0156Z"
                                                            fill="#999999" />
                                                    </g>
                                                </g>
                                            </svg>
                                        </li>
                                        <li>
                                            <svg width="33" height="24" viewBox="0 0 33 24" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <g>
                                                    <g>
                                                        <path
                                                            d="M10.5859 17.0391H11.9141V18.2188C11.9141 19.8906 12.7969 20.7656 14.4844 20.7656H22.4062C24.0938 20.7656 24.9766 19.8906 24.9766 18.2188V10.2422C24.9766 8.57031 24.0938 7.69531 22.4062 7.69531H21.0781V6.52344C21.0781 4.85156 20.1953 3.97656 18.5078 3.97656H10.5859C8.89062 3.97656 8.01562 4.85156 8.01562 6.52344V14.4922C8.01562 16.1719 8.89062 17.0391 10.5859 17.0391ZM10.6875 15.4844C9.96875 15.4844 9.57031 15.1094 9.57031 14.3516V6.66406C9.57031 5.90625 9.96875 5.53906 10.6875 5.53906H18.4062C19.1172 5.53906 19.5234 5.90625 19.5234 6.66406V7.69531H14.4844C12.7969 7.69531 11.9141 8.57031 11.9141 10.2422V15.4844H10.6875ZM14.5859 19.2031C13.8672 19.2031 13.4766 18.8281 13.4766 18.0781V10.3828C13.4766 9.63281 13.8672 9.25781 14.5859 9.25781H22.3047C23.0234 9.25781 23.4219 9.63281 23.4219 10.3828V18.0781C23.4219 18.8281 23.0234 19.2031 22.3047 19.2031H14.5859Z"
                                                            fill="#999999" />
                                                    </g>
                                                </g>
                                            </svg>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="figma-colect">
                                <a href="#demo" className="btn-see-demo">
                                    <img src="images/folder-arrow.webp" alt="" />
                                </a>
                                <div className="infiniteSlide-demo-list tf-grid-layout sm-col-2">
                                    <div className="infiniteSlide-demo">
                                        <div className="infiniteSlide infiniteSlide-wrapper" data-clone="3" data-style="up">

                                            <div className="infiniteSlide-slide">
                                                <div className="card-demo hover-img">
                                                    <a href="#" className="demo-image img-style">
                                                        <img loading="lazy" width="594" height="424"
                                                            src="images/slider-1.webp" alt="Image" />
                                                    </a>
                                                    <div className="demo-content">
                                                        <a href="#" className="demo_name h4 fw-medium text-red link">
                                                            Dashboard
                                                        </a>
                                                        <p className="demo_desc text-body-2">
                                                            Let’s Get Started
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="infiniteSlide-slide">
                                                <div className="card-demo hover-img">
                                                    <a href="#" className="demo-image img-style">
                                                        <img loading="lazy" width="594" height="424"
                                                            src="images/slider-2.webp" alt="Image" />
                                                    </a>
                                                    <div className="demo-content">
                                                        <a href="#" className="demo_name h4 fw-medium text-red link">
                                                            Manage Live Streams
                                                        </a>
                                                        <p className="demo_desc text-body-2">
                                                            Monitor and Manage All Streams
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="infiniteSlide-slide">
                                                <div className="card-demo hover-img">
                                                    <a href="#" className="demo-image img-style">
                                                        <img loading="lazy" width="594" height="424"
                                                            src="images/slider-3.webp" alt="Image" />
                                                    </a>
                                                    <div className="demo-content">
                                                        <a href="#" className="demo_name h4 fw-medium text-red link">
                                                            Manage Recordings
                                                        </a>
                                                        <p className="demo_desc text-body-2">
                                                            Saved Streams Hub For You
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="infiniteSlide-slide">
                                                <div className="card-demo hover-img">
                                                    <a href="#" className="demo-image img-style">
                                                        <img loading="lazy" width="594" height="424"
                                                            src="images/slider-4.webp" alt="Image" />
                                                    </a>
                                                    <div className="demo-content">
                                                        <a href="#" className="demo_name h4 fw-medium text-red link">
                                                            Manage Account
                                                        </a>
                                                        <p className="demo_desc text-body-2">
                                                            Your Account, Your Control
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="infiniteSlide-slide">
                                                <div className="card-demo hover-img">
                                                    <a href="#" className="demo-image img-style">
                                                        <img loading="lazy" width="594" height="424"
                                                            src="images/slider-5.webp" alt="Image" />
                                                    </a>
                                                    <div className="demo-content">
                                                        <a href="#" className="demo_name h4 fw-medium text-red link">
                                                            Watch Live
                                                        </a>
                                                        <p className="demo_desc text-body-2">
                                                            You Live View Portal
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="infiniteSlide-demo d-none d-sm-block">
                                        <div className="infiniteSlide infiniteSlide-wrapper" data-clone="3" data-style="down">

                                            <div className="infiniteSlide-slide">
                                                <div className="card-demo hover-img">
                                                    <a href="#" className="demo-image img-style">
                                                        <img loading="lazy" width="594" height="424"
                                                            src="images/slider-6.webp" alt="Image" />
                                                    </a>
                                                    <div className="demo-content">
                                                        <a href="#" className="demo_name h4 fw-medium text-red link">
                                                            Watch Recordings
                                                        </a>
                                                        <p className="demo_desc text-body-2">
                                                            Watch All Your Saved Live Streams
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="infiniteSlide-slide">
                                                <div className="card-demo hover-img">
                                                    <a href="#" className="demo-image img-style">
                                                        <img loading="lazy" width="594" height="424"
                                                            src="images/slider-7.webp" alt="Image" />
                                                    </a>
                                                    <div className="demo-content">
                                                        <a href="#" className="demo_name h4 fw-medium text-red link">
                                                            Edge Alerts
                                                        </a>
                                                        <p className="demo_desc text-body-2">
                                                            Alerts and Warnings Panel
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="infiniteSlide-slide">
                                                <div className="card-demo hover-img">
                                                    <a href="#" className="demo-image img-style">
                                                        <img loading="lazy" width="594" height="424"
                                                            src="images/slider-8.webp" alt="Image" />
                                                    </a>
                                                    <div className="demo-content">
                                                        <a href="#" className="demo_name h4 fw-medium text-red link">
                                                            Drone Vision
                                                        </a>
                                                        <p className="demo_desc text-body-2">
                                                            Advanced Drone Surveillance System
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="infiniteSlide-slide">
                                                <div className="card-demo hover-img">
                                                    <a href="#" className="demo-image img-style">
                                                        <img loading="lazy" width="594" height="424"
                                                            src="images/slider-1.webp" alt="Image" />
                                                    </a>
                                                    <div className="demo-content">
                                                        <a href="#" className="demo_name h4 fw-medium text-red link">
                                                            Dashboard
                                                        </a>
                                                        <p className="demo_desc text-body-2">
                                                            Let’s Get Started
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="infiniteSlide-slide">
                                                <div className="card-demo hover-img">
                                                    <a href="#" className="demo-image img-style">
                                                        <img loading="lazy" width="594" height="424"
                                                            src="images/slider-2.webp" alt="Image" />
                                                    </a>
                                                    <div className="demo-content">
                                                        <a href="#" className="demo_name h4 fw-medium text-red link">
                                                            Manage Live Streams
                                                        </a>
                                                        <p className="demo_desc text-body-2">
                                                            Monitor and Manage All Streams
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="tf-break-wrap" data-line="4">
                    <div className="line"></div>
                    <div className="wrap">
                        <span className="dot-square"></span>
                        <span className="dot-square"></span>
                    </div>
                </div>


                <div className="section-feature-landing flat-spacing-12">
                    <div className="container-6">
                        <div className="landing-heading">
                            <div className="land-tag wow fadeInUp">
                                <div className="ic-wrap left">
                                    <i className="icon icon-pixels-right"></i>
                                </div>
                                <span className="text-uppercase text-primary fw-semibold lh-20">
                                    Features That Work For You
                                </span>
                                <div className="ic-wrap right">
                                    <i className="icon icon-pixels-left"></i>
                                </div>
                            </div>
                            <p className="title text-56 text-black fw-medium letter-space--3 wow fadeInUp">
                                Control the Sky Like 
                                <span className="animationtext letters rotate-3 text-primary ps-sm-3">
                                    <span className="cd-words-wrapper">
                                        <span className="item-text is-visible">Never&nbsp;Before</span>
                                        <span className="item-text is-hidden">Never&nbsp;Before</span>
                                        <span className="item-text is-hidden">Never&nbsp;Before</span>
                                    </span>
                                </span>
                            </p>
                            <p className="desc fw-medium text-body-2 cl-text-3 wow fadeInUp">
                                Manage live broadcasts and HD recordings easily<br className="d-none d-md-block" /> with our seamless streaming system.
                            </p>
                        </div>
                    </div>
                    <div className="content-wrap">
                        <div className="container-6">
                            <div className="row align-items-lg-center">
                                <div className="col-sm-6 col-lg-4">
                                    <div className="wg-landing-feature wow fadeInUp">
                                        <div className="ic">
                                            <div className="tf-btn-2 style-icon">
                                                <div className="wrap-text text-body-2 fw-medium text-white">
                                                    <img src="images/live.svg" alt="" className="" />
                                                </div>
                                            </div>
                                        </div>
                                        <p className="feature-title text-sub-head fw-medium text-black">
                                            Adaptive Live Streaming
                                        </p>
                                        <div className="br-line"></div>
                                        <p className="feature-desc fw-medium cl-gray-50">
                                            Stream in multiple resolutions ranging from 240p to 2K for seamless viewing.
                                        </p>
                                    </div>
                                    <div className="wg-landing-feature wow fadeInUp">
                                        <div className="ic">
                                            <div className="tf-btn-2 style-icon">
                                                <div className="wrap-text text-body-2 fw-medium text-white">
                                                    <img src="images/video-recording.svg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <p className="feature-title text-sub-head fw-medium text-black">
                                            Auto Recording Storage
                                        </p>
                                        <div className="br-line"></div>
                                        <p className="feature-desc fw-medium cl-gray-50">
                                            All live streams are automatically saved with a dedicated size, time, and timestamps.
                                        </p>
                                    </div>
                                    <div className="wg-landing-feature wow fadeInUp mb-sm-0">
                                        <div className="ic">
                                            <div className="tf-btn-2 style-icon">
                                                <div className="wrap-text text-body-2 fw-medium text-white">
                                                    <img src="images/recording-control.svg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <p className="feature-title text-sub-head fw-medium text-black">
                                            Easy Recording Control
                                        </p>
                                        <div className="br-line"></div>
                                        <p className="feature-desc fw-medium cl-gray-50">
                                            Handle different recordings with instant preview, publish, and download features.
                                        </p>
                                    </div>
                                </div>
                                <div className="offset-lg-1 col-lg-2 d-none d-lg-block">
                                    <div className="wow fadeZoom">
                                        <a href="#" className="action tf-btn-2 style-2">
                                            <div className="wrap-text text-body-2 fw-medium text-white">
                                                <div className="ic">
                                                    <img src="images/feature-logo.webp" alt="" />
                                                </div>
                                                <span className="text drone-stream-text">Stream</span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="col-sm-6 offset-lg-1 col-lg-4">
                                    <div className="wg-landing-feature wow fadeInUp">
                                        <div className="ic">
                                            <div className="tf-btn-2 style-icon">
                                                <div className="wrap-text text-body-2 fw-medium text-white">
                                                    <img src="images/playback.svg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <p className="feature-title text-sub-head fw-medium text-black">
                                            Smooth Playback
                                        </p>
                                        <div className="br-line"></div>
                                        <p className="feature-desc fw-medium cl-gray-50">
                                            Watch all recordings anytime, anywhere with smooth and HD playback.
                                        </p>
                                    </div>
                                    <div className="wg-landing-feature wow fadeInUp">
                                        <div className="ic">
                                            <div className="tf-btn-2 style-icon">
                                                <div className="wrap-text text-body-2 fw-medium text-white">
                                                    <img src="images/download.svg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <p className="feature-title text-sub-head fw-medium text-black">
                                            Secure Downloads
                                        </p>
                                        <div className="br-line"></div>
                                        <p className="feature-desc fw-medium cl-gray-50">
                                            Download all recordings with unbeatable safety and highly trustworthy access.
                                        </p>
                                    </div>
                                    <div className="wg-landing-feature wow fadeInUp mb-0">
                                        <div className="ic">
                                            <div className="tf-btn-2 style-icon">
                                                <div className="wrap-text text-body-2 fw-medium text-white">
                                                    <img src="images/ai-track.svg" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <p className="feature-title text-sub-head fw-medium text-black">
                                            AI Smart Tracking
                                        </p>
                                        <div className="br-line"></div>
                                        <p className="feature-desc fw-medium cl-gray-50">
                                            Track all animals, individuals, and objects with immediate AI-based insights.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="side-line-main d-none d-lg-block wow fadeIn">
                            <div className="container-6">
                                <div className="row">
                                    <div className="col-lg-4 mx-auto">
                                        <div className="side-line-wrap">
                                            <div className="link-break-line left">
                                                <div className="link-break-line">
                                                    <span className="item top"></span>
                                                    <span className="item bottom"></span>
                                                </div>
                                            </div>
                                            <div className="link-break-center">
                                                <span className="simu-electric left"></span>
                                                <span className="simu-electric right"></span>
                                            </div>
                                            <div className="link-break-line right">
                                                <span className="item top"></span>
                                                <span className="item bottom"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="tf-break-wrap" data-line="4">
                    <div className="line"></div>
                    <div className="wrap">
                        <span className="dot-square"></span>
                        <span className="dot-square"></span>
                    </div>
                </div>
            </div>


            {/* <section className="section-demo container-full" id="demo">
                <div className="s-desc">
                    <div className="tag">
                        New
                    </div>
                    <p className="text-linear text-body-2 fw-medium">
                        The huge collection gets bigger and bigger everyday. Stay tuned!
                    </p>
                </div>
                <div className="main-demo-list flat-spacing-13">
                    <div className="container-6">
                        <div className="landing-heading">
                            <div className="land-tag wow fadeInUp">
                                <div className="ic-wrap left">
                                    <i className="icon icon-pixels-right"></i>
                                </div>
                                <span className="text-uppercase text-primary fw-semibold lh-20">
                                    Award-Winning Design Collection
                                </span>
                                <div className="ic-wrap right">
                                    <i className="icon icon-pixels-left"></i>
                                </div>
                            </div>
                            <p className="title text-56 text-black fw-medium letter-space--3 wow fadeInUp">
                                Start Building With 9+ <br className="d-none d-md-block" />
                                Complete
                                <span className="animationtext letters rotate-3 text-primary ps-sm-3">
                                    <span className="cd-words-wrapper">
                                        <span className="item-text is-visible">Demo &nbsp; Websites</span>
                                        <span className="item-text is-hidden">Demo &nbsp; Websites</span>
                                        <span className="item-text is-hidden">Demo &nbsp; Websites</span>
                                    </span>
                                </span>
                            </p>
                            <p className="desc fw-medium text-body-2 cl-text-3 wow fadeInUp">
                                Discover 9+ beautifully crafted home demos. Fully flexible and customizable
                                <br className="d-none d-md-block" />
                                combine sections to design your site the way you want.
                            </p>
                        </div>
                        <div className="tf-grid-layout sm-col-2 gap-20">
                            <div className="card-demo hover-img wow fadeInUpZoom">
                                <a href="./demo-lunex/index.html" target="_blank" className="demo-image img-style">
                                    <img loading="lazy" width="594" height="424" src="images/slider-1.webp"
                                        alt="Image" />
                                </a>
                                <div className="demo-content">
                                    <a href="./demo-lunex/index.html" target="_blank"
                                        className="demo_name h4 fw-medium text-black link">
                                        Lunex
                                    </a>
                                    <p className="demo_desc text-body-2">
                                        Finance & Accounting
                                    </p>
                                </div>
                            </div>
                            <div className="card-demo hover-img wow fadeInUpZoom">
                                <a href="./demo-camping/index.html" target="_blank" className="demo-image img-style">
                                    <img loading="lazy" width="594" height="424" src="images/slider-2.webp"
                                        alt="Image" />
                                </a>
                                <div className="demo-content">
                                    <a href="./demo-camping/index.html" target="_blank"
                                        className="demo_name h4 fw-medium text-black link">
                                        Camping
                                    </a>
                                    <p className="demo_desc text-body-2">
                                        Travel & Tourism
                                    </p>
                                </div>
                            </div>
                            <div className="card-demo hover-img wow fadeInUpZoom">
                                <a href="./demo-business/index.html" target="_blank" className="demo-image img-style">
                                    <img loading="lazy" width="594" height="424" src="images/slider-3.webp"
                                        alt="Image" />
                                </a>
                                <div className="demo-content">
                                    <a href="./demo-business/index.html" target="_blank"
                                        className="demo_name h4 fw-medium text-black link">
                                        Lunova
                                    </a>
                                    <p className="demo_desc text-body-2">
                                        Business & Finance Blog
                                    </p>
                                </div>
                            </div>
                            <div className="card-demo hover-img wow fadeInUpZoom">
                                <a href="./demo-agency/index.html" target="_blank" className="demo-image img-style">
                                    <img loading="lazy" width="594" height="424" src="images/slider-4.webp"
                                        alt="Image" />
                                </a>
                                <div className="demo-content">
                                    <a href="./demo-agency/index.html" target="_blank"
                                        className="demo_name h4 fw-medium text-black link">
                                        Auvora
                                    </a>
                                    <p className="demo_desc text-body-2">
                                        Creative Agency
                                    </p>
                                </div>
                            </div>
                            <div className="card-demo hover-img wow fadeInUpZoom">
                                <a href="./demo-cosmetic/index.html" target="_blank" className="demo-image img-style">
                                    <img loading="lazy" width="594" height="424" src="images/slider-5.webp"
                                        alt="Image" />
                                </a>
                                <div className="demo-content">
                                    <a href="./demo-cosmetic/index.html" target="_blank"
                                        className="demo_name h4 fw-medium text-black link">
                                        Ametic
                                    </a>
                                    <p className="demo_desc text-body-2">
                                        Beauty & Wellness Store
                                    </p>
                                </div>
                            </div>
                            <div className="card-demo hover-img wow fadeInUpZoom">
                                <a href="./demo-fimoor/index.html" target="_blank" className="demo-image img-style">
                                    <img loading="lazy" width="594" height="424" src="images/slider-6.webp"
                                        alt="Image" />
                                </a>
                                <div className="demo-content">
                                    <a href="./demo-fimoor/index.html" target="_blank"
                                        className="demo_name h4 fw-medium text-black link">
                                        Fimoor
                                    </a>
                                    <p className="demo_desc text-body-2">
                                        Software & SaaS
                                    </p>
                                </div>
                            </div>
                            <div className="card-demo hover-img wow fadeInUpZoom">
                                <a href="./demo-architect/index.html" target="_blank" className="demo-image img-style">
                                    <img loading="lazy" width="594" height="424" src="images/slider-7.webp"
                                        alt="Image" />
                                </a>
                                <div className="demo-content">
                                    <a href="./demo-architect/index.html" target="_blank"
                                        className="demo_name h4 fw-medium text-black link">
                                        Forme
                                    </a>
                                    <p className="demo_desc text-body-2">
                                        Architecture
                                    </p>
                                </div>
                            </div>
                            <div className="card-demo hover-img wow fadeInUpZoom">
                                <a href="./demo-portfolio/index.html" target="_blank" className="demo-image img-style">
                                    <img loading="lazy" width="594" height="424" src="images/slider-8.webp"
                                        alt="Image" />
                                </a>
                                <div className="demo-content">
                                    <a href="./demo-portfolio/index.html" target="_blank"
                                        className="demo_name h4 fw-medium text-black link">
                                        Coner
                                    </a>
                                    <p className="demo_desc text-body-2">
                                        Creative Agency
                                    </p>
                                </div>
                            </div>

                            <div className="wd-full text-center wow fadeInUp">
                                <a href="https://1.envato.market/gOZ4K0" target="_blank" className="tf-btn-2">
                                    <div className="wrap-text text-body-2 fw-medium text-white">
                                        <span className="text text-linear">
                                            Request Demo
                                        </span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

        </>
    );
}